import { render, staticRenderFns } from "./SupportChat.vue?vue&type=template&id=8eef7a22&scoped=true"
import script from "./SupportChat.vue?vue&type=script&lang=js"
export * from "./SupportChat.vue?vue&type=script&lang=js"
import style0 from "./SupportChat.vue?vue&type=style&index=0&id=8eef7a22&prod&lang=sass&rel=stylesheets%2Fsass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eef7a22",
  null
  
)

export default component.exports